export default __webpack_public_path__ + "static/media/phone-icon.b63185cd.svg";